import {motion} from "framer-motion";
import styles from './Skills.module.css'


import {IoLogoReact} from "react-icons/io5";
import {BiLogoTypescript, BiLogoJavascript, BiLogoRedux, BiLogoTailwindCss} from "react-icons/bi"
import { FaGithub } from "react-icons/fa";
import {SiNextdotjs} from "react-icons/si"
import { SiFramer,SiCypress,SiJest,SiMui } from "react-icons/si";


const Skills = () => {
    return (
        <section className={styles.skills} id='skills'>
            <div className={styles.width}>
                <div className={styles.titleWrapper}>
                    <h1 className={styles.title}>My Skills </h1>
                    <span className={styles.bgTitle}>Skills</span>
                </div>
                <div className={styles.bubblesWrapper}>
                    <motion.div className={styles.bubble}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <IoLogoReact className={styles.icon} style={{fill: "#12c7ef"}}/>
                        <h1 className={styles.skillTitle} style={{color: "#12c7ef"}}>React</h1>
                    </motion.div>
                    <motion.div className={`${styles.bubble}`}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <BiLogoTypescript className={styles.icon} style={{fill: "#128cef"}}/>
                        <h1 className={styles.skillTitle} style={{color: "#128cef"}}>TypeScript</h1>
                    </motion.div>
                    <motion.div className={`${styles.bubble} `}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <BiLogoJavascript className={styles.icon} style={{fill: "#eacd0d"}}/>
                        <h1 className={styles.skillTitle} style={{color: "#eacd0d"}}>JavaScript</h1>
                    </motion.div>

                    <motion.div className={`${styles.bubble} `}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <SiNextdotjs className={styles.icon}/>
                        <h1 className={styles.skillTitle}>NextJS</h1>
                    </motion.div>

                    <motion.div className={`${styles.bubble} `}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <BiLogoRedux className={styles.icon} style={{fill: "#4c0974"}}/>
                        <h1 className={styles.skillTitle} style={{color: "#4c0974"}}>Redux</h1>
                    </motion.div>

                    <motion.div className={`${styles.bubble} `}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <BiLogoTailwindCss className={styles.icon} style={{fill: "#066ff8"}}/>
                        <h1 className={styles.skillTitle} style={{color: "#066ff8"}}>TailwindCSS</h1>
                    </motion.div>

                    <motion.div className={`${styles.bubble} `}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <SiFramer className={styles.icon} style={{fill: "#ffffff"}}/>
                        <h1 className={styles.skillTitle} style={{color: "#ffffff"}}>Framer motion</h1>
                    </motion.div>
                    <motion.div className={`${styles.bubble} `}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <SiCypress className={styles.icon} style={{fill: "#31ad28"}}/>
                        <h1 className={styles.skillTitle} style={{color: "#31ad28"}}>Cypress test</h1>
                    </motion.div>
                    <motion.div className={`${styles.bubble} `}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <FaGithub className={styles.icon} style={{fill: "#000000"}}/>
                        <h1 className={styles.skillTitle} style={{color: "#000000"}}>Git</h1>
                    </motion.div>
                    <motion.div className={`${styles.bubble} `}
                                drag
                                dragConstraints={{left: 0, right: 0, top: 0, bottom: 0}}
                                dragTransition={{bounceStiffness: 600, bounceDamping: 100}}
                                dragElastic={0.2}
                                whileHover={{scale: 1.2}}
                                whileTap={{boxShadow: "0px 0px 15px rgba(0,0,0,0.2)"}}
                    >
                        <SiJest className={styles.icon} style={{fill: "#cb0e0e"}}/>
                        <h1 className={styles.skillTitle} style={{color: "#cb0e0e"}}>Jest</h1>
                    </motion.div>
                </div>
            </div>
        </section>
    )
}


export default Skills